import React, { CSSProperties } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

type ButtonVariant = "primary" | "secondary" | "danger" | "success" | "warning" | "info" | "light" | "dark" | "link";
type ButtonType = "button" | "submit";

type ButtonProps = {
    onClick?: () => void;
    children?: React.ReactNode;
    disabled?: boolean;
    className?: string;
    type?: ButtonType;
    variant?: ButtonVariant;
    tooltip?: string;
    round?: boolean;
    style?: CSSProperties;
};

function Button({
    onClick,
    children = "",
    disabled = false,
    className = "",
    type = "button",
    variant = "primary",
    tooltip = "",
    round = false,
    style = {}
}: ButtonProps) {
    if (round) {
        style = {
            ...style,
            borderRadius: "50%"
        };
    }

    const button = (
        <button
            style={style}
            className={`btn btn-${variant} ${className}`}
            onClick={onClick}
            disabled={disabled}
            type={type}
        >
            {children}
        </button>
    );

    if (tooltip) {
        const tooltipElement = <Tooltip>{tooltip}</Tooltip>;

        return (
            <OverlayTrigger overlay={tooltipElement} placement="top" delay={{ show: 200, hide: 0}}>
                <div className="d-inline-block">{button}</div>
            </OverlayTrigger>
        );
    }

    return button;
}

export default Button;
